import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';

@Component({
  selector: 'app-ai-engine-view-content',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatTabsModule
  ],
  templateUrl: './view-content.component.html',
  styleUrls: ['./view-content.component.scss']
})
export class AiEngineViewContentComponent implements OnInit {
  selectedContentType: string = 'text';
  contentTypes: string[] = ['image', 'text', 'analysis', 'video', 'avatar'];

  constructor() { }

  ngOnInit(): void {
  }

  selectContentType(type: string): void {
    this.selectedContentType = type;
  }

  getContentTypeLabel(type: string): string {
    switch(type) {
      case 'text': return 'Text Content';
      case 'image': return 'Images';
      case 'video': return 'Videos';
      case 'avatar': return 'Avatars';
      case 'analysis': return 'Analysis';
      default: return type;
    }
  }
}